const c = "https://portal.usepylon.com/acto/forms/support", n = "https://acto-academy.help.usepylon.com/";
function p({
  name: o,
  email: t
}) {
  const r = new URLSearchParams({ name: o, email: t });
  return `${c}?${r.toString()}`;
}
export {
  n as PYLON_HELP_CENTER_URL,
  c as PYLON_SUPPORT_FORM_URL,
  p as buildPylonSupportUrl
};
//# sourceMappingURL=support.js.map
